import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getEKGImportSelector } from '../selectors'
import { IEKGImportState } from '../store/ekgImport.types'
import { saveReportAttachments } from '../store/ekgImport.actions'
import { EKGImportConstants } from '../store/ekgImport.constants'

export function* deleteReportAttachment() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)
  const { reportAttachments, reportAttachmentToDelete }: IEKGImportState = yield select(getEKGImportSelector)

  if (!pcrId || !reportAttachmentToDelete) return

  try {
    const newReportAttachments = reportAttachments.filter((reportAttachment) => {
      return reportAttachment.id !== reportAttachmentToDelete
    })
    yield put(saveReportAttachments(newReportAttachments))

    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcrDoc._ekgReportAttachments) {
      const newEkgReportAttachments = pcrDoc._ekgReportAttachments.filter((reportAttachment) => {
        return reportAttachment.id !== reportAttachmentToDelete
      })

      pcrDoc._ekgReportAttachments = newEkgReportAttachments
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)
    }
  } catch (e) {
    yield put(throwPcrException(e))
  }
}

export function* deleteReportAttachmentSaga() {
  yield takeLatest([EKGImportConstants.DELETE_REPORT_ATTACHMENT], performWithMutexHOG, deleteReportAttachment)
}
